import React from "react";
import styled from "styled-components/macro";
import Link from "ui/Link";
import Typography from "ui/Typography";
import { theme } from "ui/theme";
import { HelpLinks } from "utils/helpLinks";
import { EventName } from "utils/analytics/analyticsConstants";

const $Container = styled.div`
  background-color: ${theme.ColorSpace500};
  padding: 1rem;
  text-align: center;
`;

export default function TeacherPreviewBanner() {
  return (
    <$Container>
      <Typography size="bodySansSerif" color="ColorWhite">
        <b>This is where your students can enter their connect code. </b>
        Want to learn more about connect codes? Visit the{" "}
        <Link
          href={HelpLinks.CONNECT_CODE}
          analyticsName={
            EventName.StudentConnectCodeSignupPage.CLICKED_HELP_CENTER_LINK
          }
          opensInNewTab
          isOnDarkBackground
        >
          Help Center
        </Link>
        .
      </Typography>
    </$Container>
  );
}
